import { isPhoneTooShort, isFrenchPhoneFormatInvalid } from '@/hooks/usePaymentValidation';

/**
 * Billing information form component
 * @param {object} props
 * @param {object} props.cart - Cart object
 * @param {function} props.setCart - Function to update cart
 * @param {boolean} props.isSameInfo - Whether billing info matches delivery info
 * @param {object} props.refs - Object containing refs for form inputs
 */
const BillingInfoForm = ({ cart, setCart, isSameInfo, refs }) => {
	const { billingAddressRef, billingLastNameRef, billingFirstNameRef, billingPhoneRef } = refs;
	const billingPhoneValue = isSameInfo ? cart?.delivery_phone : cart?.billing_phone;
	const isBillingPhoneTooShort = !isSameInfo && isPhoneTooShort(billingPhoneValue);
	const isBillingPhoneFormatInvalid = !isSameInfo && isFrenchPhoneFormatInvalid(billingPhoneValue);
	const isBillingPhoneInvalid = isBillingPhoneTooShort || isBillingPhoneFormatInvalid;

	return (
		<div className="shadow-lg px-2 pb-4 rounded-lg w-full bg-white lg:pb-4 lg:pb-8">
			<h3 className="text-center mb-4 text-md md:text-xl">Information de facturation</h3>
			<div className="grid grid-cols-2 w-full">
				<input
					ref={billingAddressRef}
					type="text"
					id="billing_address"
					name="billing_address"
					placeholder="Adresse de facturation*"
					className="col-span-2 mb-4 shadow-lg py-1 px-4 border border-black rounded-full text-xs md:text-md"
					onChange={(e) => setCart((prevState) => ({ ...prevState, billing_address: e.target.value }))}
					disabled={isSameInfo}
				/>

				<div className="mb-4 col-span-2 grid grid-cols-2 gap-2 w-full">
					<input
						ref={billingLastNameRef}
						type="text"
						id="billing_lastname"
						name="billing_lastname"
						placeholder="Nom*"
						className="shadow-lg py-1 px-4 border border-black rounded-full w-full text-xs md:text-md"
						onChange={(e) => setCart((prevState) => ({ ...prevState, billing_lastname: e.target.value }))}
						value={isSameInfo ? cart?.delivery_lastname : cart?.billing_lastname}
						disabled={isSameInfo}
					/>

					<input
						ref={billingFirstNameRef}
						type="text"
						id="billing_firstname"
						name="billing_firstname"
						placeholder="Prenom*"
						className="shadow-lg py-1 px-4 border border-black rounded-full w-full text-xs md:text-md"
						onChange={(e) => setCart((prevState) => ({ ...prevState, billing_firstname: e.target.value }))}
						value={isSameInfo ? cart?.delivery_firstname : cart?.billing_firstname}
						disabled={isSameInfo}
					/>
				</div>

				<div className="mb-4 col-span-2 grid grid-cols-1 gap-2 w-full">
					<div className="relative">
						{isBillingPhoneTooShort && (
							<p className="ml-2 mb-1 text-xs text-red-500 font-bold">Numéro trop court</p>
						)}
						{isBillingPhoneFormatInvalid && (
							<p className="ml-2 mb-1 text-xs text-red-500 font-bold">Format français invalide (0X XX XX XX XX)</p>
						)}
						<input
							ref={billingPhoneRef}
							type="tel"
							id="billing_phone"
							name="billing_phone"
							placeholder="Tel* (0X XX XX XX XX)"
							className={`shadow-lg py-1 px-4 rounded-full w-full text-xs md:text-md ${isBillingPhoneInvalid ? 'border border-red-500' : 'border border-black'}`}
							onChange={(e) => setCart((prevState) => ({ ...prevState, billing_phone: e.target.value }))}
							value={billingPhoneValue}
							disabled={isSameInfo}
							required
						/>
					</div>
				</div>

				<input
					type="text"
					id="billing_company"
					name="billing_company"
					placeholder="Entreprise"
					className="col-span-2 shadow-lg py-1 px-4 border border-black rounded-full resize-none text-xs md:text-md"
					onChange={(e) => setCart((prevState) => ({ ...prevState, billing_company: e.target.value }))}
				/>
			</div>
		</div>
	);
};

export default BillingInfoForm;

